export default {
  'component.vitecmanagement.title': 'Vitec administrasjon',
  'component.vitecmanagement.addvitec': 'Legg til vitec',
  'component.vitecmanagement.editvitec': 'Rediger vitec',
};
